import { api } from '../../AxiosConfig';

class FilaEsperaService {
    createCliente(data: {
        estabId: string;
        servicoId: string;
        servicosExtrasIds?: string[];
        attendantId?: string;
        preferredStartAt: Date | string;
        preferredEndAt: Date | string;
        timeWindowStartMinutes?: number;
        timeWindowEndMinutes?: number;
    }) {
        return api.post('/fila-espera/cliente/create', data);
    }

    findAllCliente() {
        return api.get('/fila-espera/cliente/findAll');
    }

    cancelCliente(entryId: string) {
        return api.patch('/fila-espera/cliente/cancel', { entryId });
    }

    accept(entryId: string) {
        return api.post('/fila-espera/accept', { entryId });
    }

    assign(
        entryId: string,
        data: {
            attendantId: string;
            startAt?: Date;
            localDate?: string;
            startMinutes: number;
            observation?: string;
            valor?: number;
            priceManual?: boolean;
        }
    ) {
        return api.post('/fila-espera/assign', { entryId, ...data });
    }

    findAll(params?: { status?: string; servicoId?: string; attendantId?: string }) {
        return api.get('/fila-espera/findAll', { params });
    }

    updateStatus(entryId: string, status: string) {
        return api.patch('/fila-espera/update-status', { entryId, status });
    }
}

export { FilaEsperaService };
